"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasetRunsTableCols = void 0;
exports.isClickhouseFilterColumn = isClickhouseFilterColumn;
exports.datasetRunsTableColsWithOptions = datasetRunsTableColsWithOptions;
const typeHelpers_1 = require("./typeHelpers");
/**
 * Columns that can be filtered using basic PostgreSQL dataset run data
 * (don't require aggregated metrics from ClickHouse)
 */
const CLICKHOUSE_FILTER_COLUMNS = [
    "Scores (categorical)",
    "Scores (numeric)",
    "Scores (boolean)",
];
const CLICKHOUSE_FILTER_COLUMNS_SET = new Set(CLICKHOUSE_FILTER_COLUMNS);
/**
 * Returns true if the dataset run filter column requires DRI metrics from ClickHouse.
 *
 * This function determines data source requirements by checking if the column
 * needs aggregated metrics that are only available in ClickHouse dataset_run_items_rmt.
 *
 * @param column - The dataset run filter column ID to check
 * @returns true if requires ClickHouse DRI metrics, false if PostgreSQL data is sufficient
 */
function isClickhouseFilterColumn(column) {
    return CLICKHOUSE_FILTER_COLUMNS_SET.has(column);
}
exports.datasetRunsTableCols = [
    {
        name: "Scores (numeric)",
        id: "agg_scores_avg",
        type: "numberObject",
        internal: "agg_scores_avg",
        nullable: true,
    },
    {
        name: "Scores (categorical)",
        id: "agg_score_categories",
        type: "categoryOptions",
        internal: "agg_score_categories",
        options: [], // to be filled in at runtime
        nullable: true,
    },
    {
        name: "Scores (boolean)",
        id: "agg_score_booleans",
        type: "booleanObject",
        internal: "agg_score_booleans",
        nullable: true,
    },
];
function datasetRunsTableColsWithOptions(options, cols = exports.datasetRunsTableCols) {
    return cols.map((col) => {
        if (col.id === "agg_scores_avg") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.agg_scores_avg ?? []);
        }
        if (col.id === "agg_score_categories") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.agg_score_categories ?? []);
        }
        if (col.id === "agg_score_booleans") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.agg_score_booleans ?? []);
        }
        return col;
    });
}
